// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"055a40ff","732":"b6b37543","977":"5a358018"}[chunkId] + ".chunk.js";
};